import { observable, action, makeObservable } from 'mobx';
import agent from '../agent';
import commonStore from './commonStore';

class ResourcePlanStore {
    constructor() {
        makeObservable(this, {
            currentList: observable,
            updatingErrors: observable,
            updating: observable,
            loading: observable,
            requestParams: observable,
            deleteSuccess: observable,
            lastListLoadTime: observable,
            departmentWisePlanCount: observable,
            currentEntity: observable,
            resetLastListLoadTime: action,
            filters: observable,
            appliedFilters: observable,
            setFilter: action,
            onFilter: action,
            loadList: action,
            save: action,
            dateWiseCount: action,
            getPlan: action
        });
    }

    currentList = [];

    currentEntity = null;

    updatingErrors = null;

    updating = false;

    loading = false;

    requestParams = null;

    deleteSuccess = false;

    lastListLoadTime = null;

    departmentWisePlanCount = null;

    resetLastListLoadTime() {
        this.lastListLoadTime = new Date();
    }
    filters = {
        name: '',
    };

    appliedFilters = {
        name: '',
    };

    setFilter(name, value) {
        const filters = Object.assign({}, this.filters);
        filters[name] = value;
        this.filters = filters;
    }

    onFilter() {
        this.appliedFilters = Object.assign({}, this.filters);
    }

    clearPlanCount = action(() => {
        this.departmentWisePlanCount = null;
    })

    loadList(params) {
        return agent.Skills.list(params)
            .then(
                action(list => {
                    this.requestParams = params;
                    list.time = new Date();
                    this.lastListLoadTime = list.time;
                    this.currentList = list;
                    return list.rows;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    save(values) {
        this.updating = true;
        return agent.ResourcePlan.save(values)
            .then(
                action(data => {
                    return data;
                })
            )
            .catch(
                action(err => {
                    this.updating = false;
                    this.updatingErrors = err.response && err.response.body && err.response.body.errors;
                    throw err;
                })
            );
    }

    dateWiseCount(params = {}) {
        this.updating = true;
        return agent.ResourcePlan.dateWiseCount(params)
            .then(
                action(data => {
                    this.departmentWisePlanCount = data.dateWiseCount;
                    return data;
                })
            )
            .catch(
                action(err => {
                    this.updating = false;
                    this.updatingErrors = err.response && err.response.body && err.response.body.errors;
                    throw err;
                })
            );
    }

    getPlan(params = {}) {
        this.updating = true;
        return agent.ResourcePlan.getPlan(params)
            .then(
                action(data => {
                    this.currentEntity = data.resource_plan;
                    return data.resource_plan;
                })
            )
            .catch(
                action(err => {
                    this.updating = false;
                    this.updatingErrors = err.response && err.response.body && err.response.body.errors;
                    throw err;
                })
            );
    }



}

const _ResourcePlanStore = new ResourcePlanStore();
export default _ResourcePlanStore;